import { JSX } from 'react';

import { BenefitsSection } from '../benefits-section';
import { AboutSection } from '../about-section';
import { TopSection } from '../top-section';
import { JoinSection } from '../join-section';
import { SignatoriesSection } from '../signatories-section';
import { MediaSection } from '../media-section';
import { PrinciplesSection } from '../principles-section';

export const LandingPage = (): JSX.Element => {
  return (
    <>
      <TopSection />
      <AboutSection />
      <PrinciplesSection />
      <BenefitsSection />
      <JoinSection />
      <SignatoriesSection />
      <MediaSection />
    </>
  );
};
